export default {
  gift_code: 'ギフトコード'
}
